import React from 'react'

import pic1 from '../images/girage1.jpg'
import pic2 from '../images/girage2.jpg'
import pic3 from '../images/girage3.jpg'
import pic4 from '../images/girage9.jpg'
import girage1 from '../images/girage5.jpg'
import girage2 from '../images/girage4.jpg'
import girage6 from '../images/girage6.jpg'
// import girage3 from '../images/girage5.jpg'
// import girage4 from '../images/trailer3.jpg'
// restaurent pics
import rest1 from '../images/arabic1.jpg'
import rest2 from '../images/arabic2.jpg'
import rest3 from '../images/arabic3.jpg'
import rest4 from '../images/restaurent4.jpg'
import rest5 from '../images/restaurent5.jpg'
import rest6 from '../images/restaurent6.jpg'
import companyVideo from '../images/video.mp4'
import LocationMap from './LocationMap'


const Services = () => {
  return (
    <>

      <div className='container-fluid mt-4'>
        <h1 className='text-center bg-info'>See in Video what we offer to our clients</h1>
        <div className='container m-3'>
          <div className='row'>
            <div className='col-lg-8 offset-lg-2 jumbotron'>
              <iframe id="inlineFrameExample"
                title="company Introduction video"
                allowfullscreen='true'
                src={companyVideo}>
              </iframe>
              {/* <video loop  controls  preload='auto|metadata|none' playsInline autoPlay="false">
        <source  src={companyVideo}  type="video/mp4" />
      </video> */}
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-lg-4 col-sm-6 mb-1'>
            <img src={pic1} className='img-fluid rounded' alt='' />
          </div>
          <div className='col-lg-4 col-sm-6 mb-1 '>
            <img src={pic2} className='img-fluid rounded' alt='' />

          </div>
          <div className='col-lg-4 col-sm-6 mb-1'>
            <img src={pic3} className='img-fluid rounded' alt='' />

          </div>
        </div>
        {/* row 2 */}
        <div className='row'>
          <div className='col-lg-4 col-sm-6 mb-1'>
            <img src={girage1} className='img-fluid rounded' alt='' />
          </div>
          <div className='col-lg-4 col-sm-6 mb-1'>
            <img src={girage6} className='img-fluid  rounded' alt='' />
            <img src={pic4} className='img-fluid mb-1 rounded' alt='' />

          </div>
          <div className='col-lg-4 col-sm-6 mb-1'>
            <img src={girage2} className='img-fluid rounded' alt='' />

          </div>
        </div>
        {/* 
      Our Restaurent portion
      */}
        <h1 className='text-center bg-info'>Our Sufuani Restaurent</h1>

        <section>
          <div className='row'>
            <div className='col-lg-4 col-sm-6 mb-1'>
              <img src={rest1} className='img-fluid rounded' alt='' />
            </div>
            <div className='col-lg-4 col-sm-6 mb-1 '>
              <img src={rest2} className='img-fluid rounded' alt='' />

            </div>
            <div className='col-lg-4 col-sm-6 mb-1'>
              <img src={rest3} className='img-fluid rounded' alt='' />

            </div>
          </div>
        </section>

        <section>
          <div className='row'>
            <div className='col-lg-4 col-sm-6 mb-1'>
              <img src={rest4} className='img-fluid rounded' alt='' />
            </div>
            <div className='col-lg-4 col-sm-6 mb-1 '>
              <img src={rest5} className='img-fluid rounded' alt='' />

            </div>
            <div className='col-lg-4 col-sm-6 mb-1'>
              <img src={rest6} className='img-fluid rounded' alt='' />

            </div>
          </div>
        </section>
        {/* map  section */}
        <section></section>

      </div>
      <LocationMap />


    </>
  )
}

export default Services